import React from 'react';
import { useTranslation } from 'react-i18next';
import BG from '../../img/bg1.jpg';

function Hero() {
  const { t } = useTranslation();

  return (
    <section className="overflow-hidden relative">
      {/* ✅ Replace background image with actual <img> */}
      <img
        src={BG}
        alt="آذر شفیعی، کوچ تغذیه"
        fetchPriority="high"
        decoding="async"
        width="1920"
        height="500"
        className="w-full h-[500px] object-cover"
      />

      {/* ✅ Overlay content on top */}
      <div className="absolute top-0 left-0 right-0 bottom-0 bg-[hsla(0,0%,0%,0.75)] flex items-center justify-center">
        <div
          dir="rtl"
          className="px-6 flex md:flex-row flex-col text-center text-white md:px-12">
          <div className="mb-2 grid grid-col w-100">
            <span className="text-wrap mt-10 mb-5 text-4xl font-bold tracking-tight md:text-4xl xl:text-4xl">
              {t('brand')}
            </span>
            <span className="mb-5">لاغری اصولی و تناسب اندام بدون بازگشت</span>
          </div>

          <div className="grid grid-col items-center gap-3 justify-center md:flex-row md:justify-center">
            <a
              className="mb-2 bg-gold inline-block rounded-full border-2 border-neutral-50 px-[46px] pt-[14px] pb-[12px] text-sm font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-neutral-100 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-neutral-100 focus:border-neutral-100 focus:text-neutral-100 focus:outline-none focus:ring-0 active:border-neutral-200 active:text-neutral-200 md:mr-2 md:mb-0"
              href="https://academy.azishafiei.com/register">
              ثبت نام دوره آکادمی
            </a>
            {/* Buttons */}
            <a
              className="mb-2 bg-lighter inline-block rounded-full border-2 border-neutral-50 px-[46px] pt-[14px] pb-[12px] text-sm font-medium uppercase leading-normal text-neutral-50 transition duration-150 ease-in-out hover:border-neutral-100 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-neutral-100 focus:border-neutral-100 focus:text-neutral-100 focus:outline-none focus:ring-0 active:border-neutral-200 active:text-neutral-200 md:mr-2 md:mb-0"
              href="https://academy.azishafiei.com/register">
              ثبت نام دوره خصوصی
            </a>
            <a
              className="mb-2 inline-block bg-gold text-main rounded-full border-2 border-neutral-50 px-[46px] pt-[14px] pb-[12px] text-sm font-medium uppercase leading-normal  transition duration-150 ease-in-out hover:border-neutral-100 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-neutral-100 focus:border-neutral-100 focus:text-neutral-100 focus:outline-none focus:ring-0 active:border-neutral-200 active:text-neutral-200 md:mr-2 md:mb-0"
              href="/bodyfatcalculator">
              آنالیز هوشمند بدن شما
            </a>

            <a
              className="mb-2 bg-lighter inline-block rounded-full border-2 border-neutral-50 px-[46px] pt-[14px] pb-[12px] text-sm font-medium uppercase leading-normal text-neutral-50 transition duration-150 ease-in-out hover:border-neutral-100 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-neutral-100 focus:border-neutral-100 focus:text-neutral-100 focus:outline-none focus:ring-0 active:border-neutral-200 active:text-neutral-200 md:mr-2 md:mb-0"
              href="/result">
              مشاهده نتایج آنالیز
            </a>
          </div>
        </div>
      </div>

      {/* SVG Bottom Shape */}
      <div className="-mt-2.5 text-white md:-mt-4 lg:-mt-6 xl:-mt-10 h-[50px] scale-[2] origin-[top_center]">
        <svg viewBox="0 0 2880 48" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M 0 48 L 1437.5 48 L 2880 48 L 2880 0 L 2160 0 C 1453.324 60.118 726.013 4.51 720 0 L 0 0 L 0 48 Z"
            fill="currentColor"></path>
        </svg>
      </div>
    </section>
  );
}

export default Hero;
